export const ClearAgencyCache = async (agencyCode: string) => {
  let response: any = {};

  await fetch(`/api/sitecore/AgencyAPIAsync/ClearAgencyCache?statCode=${agencyCode}`, {
    method: 'POST',
  })
    .then((res) => res.json())
    .then(
      (res) => {
        try {
          response = JSON.parse(JSON.stringify(res));
        } catch (err: any) {
          console.error(`${'ClearAgencyCache'}() >> ${err.message}`);
        }
      },
      (error) => {
        console.error(`${'ClearAgencyCache'}() >> ${error}`);
      },
    );

  return response;
};

export const GetAgencyInfo = async (agencyCode: string): Promise<IAgencyInfo> => {
  let response: any = {};

  await fetch(`/api/sitecore/AgencyAPIAsync/GetBLAgencyInfo?agencyCode=${agencyCode}`, {
    method: 'POST',
  })
    .then((res) => res.json())
    .then(
      (res) => {
        try {
          response = JSON.parse(JSON.stringify(res));
        } catch (err: any) {
          console.error(`${'GetAgencyInfo'}() >> ${err.message}`);
        }
      },
      (error) => {
        console.error(`${'GetAgencyInfo'}() >> ${error}`);
      },
    );

  return response;
};
